import { useState, useEffect } from "react";
import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { Navbar } from "components/layout/components/Navbar";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { RecruiterCount } from "./components/RecruiterCount";
import { TalentCount } from "./components/TalentCount";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { routePath } from "config/routeMgt/routePath";
import { useGetPendingFeedback } from "features/feedback/hooks/useGetPendingFeedback";
import { useProfileCompletion } from "features/settings/hooks/useProfileCompletion";

export const Home = () => {
  const { userInfo } = useGetUserInfo();
  const { incompleteSections, isLoading: isProfileLoading } =
    useProfileCompletion();

  const {
    data: pendingFeedback,
    isLoading: pendingFeedbackLoading,
    refetch: refetchPendingFeedback,
  } = useGetPendingFeedback();
  const [searchParams] = useSearchParams();
  const skipRedirect = searchParams.get("skipRedirect") === "true";
  const refreshed = searchParams.get("refreshed") === "true";

  const [jobsSearch, setJobSearch] = useState("");
  const [jobs, setJobs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const isTalent = userInfo?.type === "talent";

  useEffect(() => {
    if (!isTalent) {
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [isTalent]);

  useEffect(() => {
    if (refreshed) {
      refetchPendingFeedback();
    }
  }, [refreshed, refetchPendingFeedback]);

  const showBanner = !isProfileLoading && incompleteSections.length > 0;

  if (
    isTalent &&
    !skipRedirect &&
    !pendingFeedbackLoading &&
    pendingFeedback &&
    pendingFeedback.length > 0
  ) {
    return <Navigate to={routePath.jobOffers} replace />;
  }

  if (isTalent && pendingFeedbackLoading) {
    return (
      <DashboardLayout>
        <div className="mx-4 mt-4">
          <div className="flex items-center gap-4 flex-wrap">
            <Navbar
              description={
                userInfo?.current_team
                  ? userInfo.current_team.name
                  : "Dashboard"
              }
              title={`Welcome back, ${userInfo?.name}`}
            />
          </div>
          <div className="text-center py-8">Loading...</div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mx-4 mt-4">
        <div className="flex items-center gap-4 flex-wrap">
          <Navbar
            description={
              userInfo?.current_team ? userInfo.current_team.name : "Dashboard"
            }
            title={`Welcome back, ${userInfo?.name}`}
          />

          {isTalent && showBanner && (
            <div className="bg-red-50 border border-red-300 rounded-md px-4 py-2 shadow-sm">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="text-red-700 font-medium">
                  ⚠️ Your profile needs attention:
                </span>

                <span className="text-red-600">
                  Complete {incompleteSections.join(", ")}
                </span>

                <div className="flex items-center gap-2">
                  {incompleteSections.map((section) => (
                    <Link
                      key={section}
                      to={
                        section === "Basic Details"
                          ? routePath.settings
                          : section === "Education"
                            ? routePath.education
                            : routePath.experience
                      }
                      className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs hover:bg-red-200 transition"
                    >
                      Go to {section} →
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {isTalent ? (
        <TalentCount jobsSearch={jobsSearch} setJobSearch={setJobSearch} />
      ) : (
        <RecruiterCount />
      )}
    </DashboardLayout>
  );
};
